const english = {
  applicationName: 'Domichain Wallet',
  unlockWallet: 'Unlock wallet',
  choosePassword: 'Choose a Password',
  pickPassword:
    'Pick a password to protect your wallet (at least 12 characters).',
  passwordTooShort: 'Use at least 12 characters.',
  passwordMismatch: 'Passwords do not match.',
  skipPassword: 'Skip (no password)',
  skipForNow: 'Skip for now',
  plaintextWarning:
    'Without a password, your recovery phrase is stored unencrypted on this device.',
  noPasswordSet: 'This wallet has no password.',
  secureWalletTitle: 'Secure your wallet',
  secureWalletDescription:
    'This wallet is stored without a password. Set one now to encrypt your recovery phrase on this device.',
  secureWalletAction: 'Encrypt wallet',
  upgradePasswordTitle: 'Update your password',
  upgradePasswordDescription:
    'Your wallet password is shorter than the current minimum of 12 characters. Choose a new password to keep protecting your recovery phrase.',
  updatePasswordAction: 'Update password',
  securingWallet: 'Securing wallet...',
  walletSecured: 'Wallet secured',
  reenterPassword: 'Re-enter your password to continue.',
  incorrectPassword: 'Incorrect password.',
  enableAutoApproveTitle: 'Enable auto-approve',
  enableAutoApproveWarning:
    'This lets the site send transactions without asking each time. Enter your password to confirm.',
  ifForgetPassword:
    'If you forget your password you will need to restore your wallet using your seed words.',
  restoreExistingWallet: 'Restore Existing Wallet',
  createNewWallet: 'Create New Wallet',
  createToHold: 'Create a new wallet to hold Domichain and DPL tokens',
  seedSafePlace:
    'Please write down the following twelve words and keep them in a safe place:',
  privateKeysStored:
    "Your private keys are only stored on your current computer or device. You will need these words to restore your wallet if your browser's storage is cleared or your device is damaged or lost.",
  iHaveSaved: 'I have saved these words in a safe place.',
  downloadMnemonic: 'Download Backup Mnemonic File (Required)',
  pleaseReenter:
    'Please re-enter your seed phrase to confirm that you have saved it.',
  pleaseType: 'Please type your seed phrase to confirm',
  newPassword: 'New Password',
  newPasswordOptional: 'New Password (Optional)',
  confirmPassword: 'Confirm Password',
  back: 'Back',
  createWallet: 'Create Wallet',
  unlockingWallet: 'Unlocking wallet...',
  password: 'Password',
  keepWalletUnlocked: 'Keep wallet unlocked',
  restoreExisting: 'Restore Existing Wallet',
  restoreUsing:
    'Restore your wallet using your twelve or twenty-four seed words. Note that this will delete any existing wallet on this device.',
  noHardwareWallet:
    'Do not enter your hardware wallet seedphrase here. Hardware wallets can be optionally connected after a web wallet is created.',
  mnemonicFailed:
    'Mnemonic validation failed. Please enter a valid BIP 39 seed phrase.',
  seedWords: 'Seed Words',
  cancel: 'Cancel',
  next: 'Next',
  addAccount: 'Add Account',
  name: 'Name',
  importPrivateKey: 'Import private key',
  pastePrivateKey: 'Import private key',
  add: 'Add',
  close: 'Close',
  addCustomNetwork: 'Add a custom network',
  url: 'URL',
  done: 'done',
  continue: 'Continue',
  export: 'Export',
  delete: 'Delete',
  send: 'Send',
  receive: 'Receive',
  wrap: 'Wrap',
  unwrap: 'Unwrap',
  wrapDomiTitle: 'Wrap DOMI',
  unwrapDomiTitle: 'Unwrap wDOMI',
  wrapDomiInfo:
    'Wrapping converts native DOMI into the wDOMI token, which can be deposited into apps that work with DPL tokens, such as FuFuture. You can unwrap back to native DOMI at any time.',
  unwrapDomiInfo:
    'Unwrapping converts wDOMI back into native DOMI in your main account.',
  wrapUsdtTitle: 'Wrap USDT',
  wrapUsdtInfo:
    'Wrapping converts legacy USDT into the wUSDT token 1:1. The bridge burns the surrendered USDT and mints the same amount of wUSDT to your wallet.',
  unwrapDomiCloseNote:
    'Unwrapping the full balance closes the wDOMI account and also returns its rent deposit.',
  wrapDomiConsolidateNote:
    'Your existing wDOMI will also be moved into your main (associated) token account; the old account is closed and its rent deposit returned.',
  unlock: 'Unlock',
  confirmAddress: 'Confirm your wallet address',
  checkLedger:
    "Check your ledger and confirm the address displayed is the address chosen. Then click 'done'.",
  addHardwareWallet: 'Add hardware wallet',
  connectLedger:
    "Connect your ledger and open the Domichain application. When you are ready, click 'continue'.",
  loadingFromHardwareWallet: 'Loading accounts from your hardware wallet',
  copied: 'Copied',
  copyToClipboard: 'Copy to Clipboard',
  editAccountName: 'Edit Account Name',
  auxiliaruAccount: 'This is an auxiliary token account.',
  viewOnDomiexplorer: 'View on Domiexplorer',
  viewDetails: 'View Details',
  tokenName: 'Token Name',
  tokenSymbol: 'Token Symbol',
  mainAccount: 'Main account',
  account: 'Account',
  refresh: 'Refresh',
  wontRecover:
    'You will not be able to recover the current accounts without the seed phrase, and the account private key. This action will delete all current accounts from your browser.',
  perventLoss:
    "To prevent loss of funds, please ensure you have the seed phrase and the private key for all current accounts. You can view it by selecting 'Export Mnemonic' in the user menu.",
  enterSeedPhase: 'Please type your seed phrase to confirm',
  deleteAndLogout: 'Delete Mnemonic & Log Out',
  editAccount: 'Edit Account',
  addressReceive: 'This address can be used to receive',
  depositAddress: 'Deposit Address',
  enterDomichainAddress: 'Enter Domichain Address',
  enterDPLAddress: 'Enter DPL token or Domichain address',
  amount: 'Amount',
  max: 'Max',
  recipientAddress: 'Recipient Address',
  use1: 'Please use the',
  use2: 'Wormhole Portal Bridge',
  use3: 'to bridge your assets.',
  save: 'SAVE',
  exportAccount: 'Export Account',
  privateKey: 'Private Key',
  reveal: 'Reveal',
  mnemonic: 'Mnemonic',
  connect: 'Connect',
  exportMnemonic: 'Export Mnemonic',
  importHardwareWallet: 'Import Hardware Wallet',
  selectAccount: 'Select Account',
  editCustomEndpoint: 'Edit Custom Endpoint',
  addCustomEndpoint: 'Add Custom Endpoint',
  hardwareWallet: 'Hardware wallet',
  selectNetwork: 'Select Network',
  selectLanguage: 'Select Language',
  connections: 'Connections',
  manageConnections: 'Manage Connections',
  wallet: 'Wallet',
  walletBalance: 'Wallet Balance',
  expandView: 'Expand View',
  appName: 'DWallet',
  disconnect: 'Disconnect',
  connectedDapps: 'Connected Dapps',
  yourReferralLink: 'Your referral link',
  sendRequest: 'Send Request',
  waitingForConfirmation: 'Waiting for Confirmation',
  withdrawFunds: 'Withdraw Funds',
  deposit: 'Deposit',
  metamaskConnected: 'Metamask connected',
  transactionPending: 'Transaction Pending',
  language: 'Language',
  confirmMnenonic: 'Confirm Mnemonic',
  creatingWallet: 'Creating Wallet...',
  walletCreated: 'Wallet Created!',
  time: 'Time',
  txHash: 'Tx Hash',
  type: 'Type',
  transfer: 'Transfer',
  other: 'Other',
  approve: 'Approve',
  deny: 'Deny',
  connectWalletDialogQuestion:
    'Allow this Dapp to access your Domichain account?',
  connectWalletDialogNotice:
    'Connect only with sites you trust. You approve every transaction; you can enable auto-approve per site in the "Connected Dapps" section.',
  network: 'Network',
  wantsToConnect: 'wants to connect to your wallet',
  allowTransactionDialogQuestion: 'Allow this Dapp to send a transaction?',
  airdrop: 'Airdrop',
  addressHasNoFunds: "This address has no funds. Are you sure it's correct?",
  mintNewToken: 'Mint New Token',
  mintNewTokenDescription:
    'Generate and receive a new valueless token. This operation requires DOMI to cover transaction fees.',
  tokenDecimals: 'Token Decimals',
  stake: 'Stake',
  delegate: 'Delegate',
  yourStake: 'Your Stake',
  stakeAccount: 'Stake Account',
  status: 'Status',
  balance: 'Balance',
  activeStake: 'Active Stake',
  inactiveStake: 'Inactive Stake',
  reward: 'Reward',
  unstake: 'Unstake',
  claim: 'Claim',
  availableForWithdraw: 'Available For Withdraw',
  totalRewardWithdrawn: 'Total Reward Withdrawn',
  totalBalanceExpected: 'Total Balance Expected',
  withdrawStake: 'Withdraw Stake',
  startStaking: 'Start Staking',
  stakingChoosePlanDescription:
    'Start staking DOMI and earn rewards by choosing one of the plans below.',
  stakingDepositDescription:
    "Deposit USDT on the BNB Smart Chain to the given deposit address with the specified token amount.\n\nOnce deposited, you'll automatically become eligible for staking.",
  stakingDelegateDescription:
    "Choose how much DOMI you'd like to stake with your validator.",
  domiHealth: {
    sectionTitle: 'DomiHealth',
    notPairedTitle: 'Not paired with an edge node',
    notPairedDescription:
      'Scan the pairing QR code shown by your DomiHealth edge node to connect this wallet to it.',
    pairButton: 'Scan pairing code',
    pairDialogTitle: 'Pair with edge node',
    scanQrButton: 'Scan QR code',
    pastePairingCodeLabel: 'Or paste the pairing JSON',
    pairingInvalid: 'That pairing code is not valid.',
    forgetEdgeNodeButton: 'Forget this edge node',
    forgetEdgeNodeConfirm:
      'Forget this edge node? You will need to scan its pairing code again to reconnect.',
    pairedWith: 'Paired with {0}',
    unlockTitle: 'Unlock your health data',
    autoUnlocking: 'Unlocking with your wallet…',
    passphraseFallbackHint:
      "This account predates automatic unlock — enter the passphrase you originally set for it.",
    passphraseLabel: 'Local passphrase',
    passphraseHint:
      'This is a separate passphrase for your data on this edge node — not your wallet password.',
    unlockButton: 'Unlock',
    incorrectPassphrase: 'Incorrect passphrase.',
    lockButton: 'Lock',
    recordsTitle: 'Health records',
    noRecords: 'No records yet.',
    addMeasurementButton: 'Add measurement',
    addMeasurementTitle: 'Add a measurement',
    metricTypeLabel: 'Metric (e.g. heart_rate, weight)',
    valueLabel: 'Value',
    unitLabel: 'Unit (optional)',
    saveButton: 'Save',
    documentTypeLabel: 'What are you uploading?',
    documentTypeLab: 'Lab report',
    documentTypeGrocery: 'Grocery receipt',
    documentTypeRestaurant: 'Restaurant receipt',
    uploadPhotoButton: 'Take a photo (e.g. lab results)',
    uploadingPhoto: 'Uploading…',
    uploadFromStorageButton: 'Choose a file from storage (photo or PDF)',
    uploadingFile: 'Uploading…',
    documentUploaded: 'Uploaded — extracting lab results in the background. Check back here in a few minutes.',
    groceryReceiptUploaded:
      'Uploaded — extracting grocery items in the background. Check back here in a few minutes.',
    restaurantReceiptUploaded:
      'Uploaded — extracting menu items in the background. Check back here in a few minutes.',
    documentAlreadyUploaded: 'This exact file has already been uploaded — nothing new was added.',
    cameraError: 'Could not take a photo.',
    filePickerError: 'Could not select or upload that file.',
    genericError: 'Something went wrong talking to the edge node: {0}',
    insecureConnectionNotice:
      "This connection does not yet verify the edge node's certificate — only use this on a network you trust.",
    claimRewardsButton: 'Claim DHT rewards',
    claimingRewards: 'Building and submitting claims…',
    noClaimsAvailable: 'Nothing to claim right now.',
    claimsSubmitted: '{0} reward claim(s) submitted.',
    claimsSkipped: '{0} record(s) were skipped: {1}',
    claimFailed: 'One claim failed: {0}',
    backupButton: 'Back up my data',
    backingUp: 'Backing up…',
    backupComplete: 'Backup created and pointer updated on-chain.',
    restoreButton: 'Restore from backup',
    restoring: 'Restoring…',
    restoreComplete: '{0} record(s) restored from backup.',
    restoreNoBackupFound: 'No backup was found for this wallet.',
    deregisterSectionTitle: 'Lost an edge node?',
    deregisterSectionDescription:
      "If you have a lost, stolen, or replaced edge node, free up its device slot so you can register a new one. You'll need that device's public key — it was printed to its own terminal/console the first time it started (\"Device identity: ...\"). This can be done using any edge node you're currently paired with, not the lost one.",
    devicePubkeyLabel: 'Lost device public key',
    deregisterButton: 'Deregister lost device',
    deregistering: 'Deregistering…',
    deregisterComplete: 'Device deregistered — its slot is now free.',
    anchoredChip: 'Anchored',
    pendingChip: 'Pending',
    wellnessAnalysisTitle: 'Wellness summary',
    chatSectionTitle: 'Health chat',
    chatSectionDescription: 'Ask the wellness assistant a question by typing, instead of speaking — runs on your edge node the same way the voice assistant does.',
    chatInputLabel: 'Ask a question about your health',
    chatSendButton: 'Send',
    chatYouLabel: 'You',
    chatAssistantLabel: 'Assistant',
    voiceSectionTitle: 'Voice assistant',
    voiceSectionDescription:
      "Speech-to-text and text-to-speech both run on your edge node, not your phone or the cloud — your voice never leaves your local network.",
    startRecordingButton: 'Start recording',
    stopRecordingButton: 'Stop recording',
    askAssistantButton: 'Ask the wellness assistant',
    saveAsNoteButton: 'Save as a voice note',
    processingVoice: 'Processing…',
    voiceTranscriptLabel: 'You said',
    voiceResponseLabel: 'Assistant',
    voiceNoteTranscribed: 'Transcribed — review it below and tap Save.',
    voiceNativeOnly: 'Voice recording is not available right now.',
    dashboardSectionTitle: 'Health dashboard',
    dashboardNoFlaggedItems: 'Nothing outside a typical range right now.',
    dashboardFlaggedItemsCount: '{0} item(s) outside a typical range',
    dashboardRefreshButton: 'Refresh',
    dashboardAskAboutButton: 'Ask about this',
    askAboutItemQuestion:
      'My {0} came back at {1} {2}, outside the typical range. What does this mean, and what lifestyle changes might help, or should I see a doctor?',
    dashboardAsking: 'Asking…',
    dashboardTypicalRangeLabel: 'Typical range',
    patientInfoLabel: 'Patient',
    reportDateLabel: 'Report date',
    purchaseDateLabel: 'Purchase date',
    processingDocument: 'Extracting lab results in the background — check back in a few minutes',
    labValuesLabel: 'Lab values',
    labValuesCount: '{0} lab value(s) recorded',
    groceryItemsCount: '{0} grocery item(s) recorded',
    restaurantItemsCount: '{0} menu item(s) recorded',
    viewerUploadedAtLabel: 'Uploaded',
    viewerPreviewUnavailable: 'No preview available for this file type ({0}). Use Download to save it to your device.',
    viewerCloseButton: 'Close',
    viewerDownloadButton: 'Download',
    viewerDownloading: 'Downloading…',
    viewerDownloadComplete: 'Saved "{0}" to your Downloads folder.',
    viewerDownloadFailed: 'Could not download this file.',
  },
  purchase: {
    title: 'Purchase',
    subtitle:
      'Buy DOMI tokens directly and start earning rewards by staking them.',
    afterPurchase: "After purchase, you'll immediately receive:",
    dominPerUsdt: '1 DOMI for every 2 USDTs',
    sesaAirdrop:
      'Spending mimium of 50 USDT will grant you 2,000 SESA tokens instantly',
  },
  newStakingDelegateDescription1: 'Staking: Stake your $DOMI for 30 days.',
  newStakingDelegateDescription2: 'Total Rewards:',
  newStakingDelegateDescription3:
    '  Existing $DOMI: Earn a total reward of 50% over the staking period.',
  newStakingDelegateDescription4:
    '  Newly Purchased $DOMI: Earn double rewards at 100%.',
  newStakingDelegateDescription5: 'Daily Withdrawals:',
  newStakingDelegateDescription6:
    '   Existing $DOMI: Withdraw 0.2% daily to your wallet or an exchange (minimum   withdrawal amount: 10).',
  newStakingDelegateDescription7:
    '   Newly Purchased $DOMI: Withdraw 0.47% daily.',
  newStakingDelegateDescription8: '',
  newStakingMinDomiAmount: 'Minimum amount: {0} DOMI',
  dailyWithdrawal: 'Daily Withdrawal',
  totalReward: 'Total Reward',
  stakeWarning:
    "You are trying to stake more Domi than purchased, meaning you won't get the increased rewards. Try staking less or purchasing more Domi.",
  stakingActivatingDescription:
    'Your DOMI will begin earning rewards in the next couple days once the stake account becomes active.',
  stakingActiveDescription:
    "Your DOMI is currently staked with a validator. You'll need to unstake to access these funds.",
  noStaking: 'No Staking plans currently available.',
  stakingPlan: 'Plan',
  stakingAnnualFee: 'Annual Fee',
  stakingProduct: 'Product',
  stakingAnnualRoi: 'Annual ROI',
  stakingLimit: 'Staking Limit',
  stakingUrl: 'Staking URL',
  unlimited: 'Unlimited',
  validator: 'Validator',
  activating: 'Activating',
  active: 'Active',
  deactivating: 'Deactivating',
  inactive: 'Inactive',
  showDepositAddress: 'Show Deposit Address',
  confirmUnstakeTitle: 'Confirm Unstaking',
  confirmUnstakeDescription:
    "Are you sure you want to unstake? You'll stop earning any rewards, but will be able to withdraw your funds.",
  installPwaTitle: 'Install DWallet',
  installPwaDescription:
    'Install the app on your device to easily access it anytime.',
  installPwaStepOne: '1. Tap on the "Share" Button',
  installPwaStepTwo: '2. Select "Add to Home Screen"',
  installPwaStepThree: '3. Go to the Home Screen, find DWallet and open it.',
  redPacketTitle: 'Happy Lunar New Year!',
  redPacketAvailable: 'Press here to claim your free Red Packet gift',
  redPacketUnavailable: 'Come back %s to claim another gift',
  redPacketSnackbar: "You've claimed %s DOMI from your Red Packet gift!",
  airdropIsAlreadyDoneToday:
    "Today's airdrop is already sent, come back tomorrow to claim it",
  errorOccurredTryAgainLater: 'An error occurred, try again later',
  settings: 'Settings',
  free: 'Free',
  welcomeAirdropTitle: 'Welcome to DWallet!',
  welcomeAirdropAvailable: 'Press here to get 1 free DOMI as a gift from us.',
  welcomeAirdropUnavailable: 'Come back %s to claim another gift.',
  welcomeAirdropSnackbar: "You've received %s DOMI as a welcome gift!",
  usdtDepositNotice:
    'This address can be used to receive USDT only from %s. Do not send tokens from other networks! After USDT is received you can use it to buy DOMI and receive a SESA airdrop',
  usdtContractAddress: 'USDT contract address:',
  exchange: 'Exchange',
  loading: 'Loading...',
  expectedFee: 'Expected fee',
  youWillReceive: 'You will receive',
  selectTheFee: 'Select the fee',
  fastest: 'Fastest',
  normal: 'Normal',
  economy: 'Economy',
  sendingTransaction: 'Sending transaction...',
  transactionConfirmed: 'Transaction confirmed',
  failedToSignAndSendAMultisigTransaction:
    'Failed to sign and send a multisig transaction',
  noAccountsFound: 'No accounts found',
  requestFailed: 'Request failed',
  noFeeRates: 'No fee rates',
  insufficientFunds: 'Insufficient funds',
  tenMinutes: '~10min',
  thirtyMinutes: '~30min',
  oneHour: '~1h',
  buyDomiItemTitle: 'Buy DOMI',
  buyDomiItemSubtitle: 'Deposit USDT to buy DOMI',
  buyDomiButton: 'Buy DOMI',
  buyDomiDialogTitle: 'Buy DOMI',
  buyDomiMinimumUsdtAmount: 'Minimum USDT amount: {0} USDT',
  buyDomiReceiveNotice:
    "After exchange, you'll immediately receive 2,000 SESA tokens and 1 DOMI for every 2 USDTs. Newly purchased DOMI qualifies for higher staking rewards of 100% for 180 days.",
  buyButton: 'Buy',
  telegramSubscriptionTitle: 'Subscribe to our social networks',
  telegramSubscriptionLink: 'Click to open in Telegram',
  telegramSubscriptionLink2: 'Telegram community link:',
  telegramInstructions1: "If you don't have Telegram:",
  telegramInstructions2: 'Install Telegram on your device',
  telegramInstructions3:
    'or scan the QR code with another device with Telegram',
  telegramInstructions4: 'Click on the link or open it in your browser',
  telegramInstructions5:
    'Press "Start" button to start chatting with out Telegram bot',
  telegramInstructions6:
    'Follow the instructions of our bot to join out Telegram community',
  telegramInstructions7: 'Go back to DWallet and press the "Continue" button',
  subscribeTwitterInstructions: 'Follow our community on Twitter:',
  twitterSubscriptionLink:
    'Click here to open on Twitter and then click "Follow" button',
  referral: {
    title: 'Referral',
    description: 'Refer friends to earn even more rewards!',
    totalReferral: 'Your total referrals',
    referralReward: 'Your {coin} referral reward',
    pendingReward: 'Pending {coin} reward',
    claim: 'Claim Referral Rewards',
    copy: 'Copy',
    referralLinkLabel: 'Referral link',
    referralLinkLoading: 'Loading referral link...',
    guide1: '1. Send your referral link to your friends.',
    guide2: '2. When they stake, you earn additional rewards.',
    earningByLevels: 'Earn referral reward at 1-10%',
    teamRewardsByLevels: 'Team Bonus',
    updateHeader: 'Update your information',
    update: 'Update',
  },
  referralTable: {
    date: 'Date',
    event: 'Event',
    walletId: 'Wallet ID',
    stakeAmount: 'Stake Amount',
    registered: 'registered',
    bonusDomi: 'bonus {0} DOMI',
    domi: '{0} DOMI',
  },
  minerStakingDescription:
    'Choose a node machine that suits your investment strategy. Each plan offers different rewards and terms.',
  price: 'Price',
  stakeRequired: 'Stake Required: ',
  dailyReward: 'Daily Reward: ',
  totalReward: 'Total Reward: ',
  totalReturn: 'Total Return: ',
  minStake: 'Minimum Stake: ',
  maxStake: 'Maximum Stake: ',
  reqLock: 'Requires Lockup: ',
  period: 'Period: ',
  buyNow: 'BUY NOW',
  orderSummary: 'Order Summary',
  insufficientBalance: 'Insufficient balance for this purchase',
  shipping: 'Shipping Information',
  name: 'Full Name',
  email: 'Email',
  number: 'Phone Number',
  address: 'Address',
  city: 'City',
  country: 'Country',
  postal: 'Postal Code',
  notes: 'Additional Notes',
  buyAI: 'Buy AI Miner',
  buyAIMSG: 'Buy a miner machine and earn rewards',
  lockPeriod: 'Release Schedule:',
  reqStake: 'Required Stake:',
  miningM: 'Node Machine: ',
  orderCon: 'Order Confirmation',
  orderThx:
    'Thank you for your order! Your node machine {} has been successfully purchased.',
  orderProcess:
    'We will process your order and contact you at {} with delivery details.',
  orderDate: 'Order Date:',
  orderTotal: 'Total Paid:',
  apiSendFail:
    "Your payment was processed successfully, but we couldn't notify our servers about your order details. This won't affect your purchase, but please click RETRY to ensure we have your shipping information.",
  yourAiNodeStake: 'Your AI Node Stake',
  deactiveStakeWarning:
    'Warning: This stake is deactivated and not earning rewards. Please Reactivate.',
  humanVerification: 'Human Verification Required',
  verificationSuccess: '✓ Verification Successful!',
  verificationSuccess2: 'You have been verified as a human user.',
  pleaseVerifyMsg:
    'Please verify that you are human by entering the characters shown below:',
  refreshCaptcha: 'Refresh Captcha',
  enterChar: 'Enter the characters above',
  enterChar2: 'Please enter the correct characters',
  fufutureItemTitle: 'FuFuture DEX',
  fufutureItemSubtitle: 'Trade decentralized options on FuFuture',
  skip: 'Skip',
  skipBackupTitle: 'Skip backup for now?',
  skipBackupDescription:
    'You can view and back up your seed words at any time from the account menu under "%s". Without a backup, you will not be able to restore your wallet if this device is lost or its data is cleared.',
  tokenStaking: {
    sectionTitle: 'Token Staking',
    stakeTitle: 'Stake',
    apr: 'APR',
    dayLock: 'day lock',
    minimum: 'min',
    projected: 'Projected rewards',
    lockedUntil: 'Locked until',
    unlocked: 'Unlocked',
    claimable: 'Claimable',
    claimed: 'Claimed',
    staked: 'Staked',
    unstaked: 'Unstaked',
    addMore: 'Add more',
    back: 'Back',
    confirmStake: 'Confirm stake',
    sending: 'Sending…',
    paused: 'paused',
    free: 'free rewards',
    daysRunway: 'days of runway',
    poolHealth: 'Pool',
    noPools: 'No staking pools are available for your tokens yet.',
    noBalance: 'You have no %s to stake. Buy some on the Marketplace first.',
    insufficientBalance: 'Insufficient balance',
    topUpRelocks:
      'Adding to your position re-locks your existing %s for the full lock period.',
    unstakeHint: 'Leave empty to withdraw everything.',
    remainderBelowMinimum: 'Remaining stake must be 0 or at least',
    rewardsPaidWithUnstake: 'Accrued rewards are paid with this withdrawal.',
    rewardsStayClaimable:
      'The reward vault cannot cover accrued rewards right now; they stay claimable.',
    rewardsPendingFunding:
      'Principal withdrawn. Rewards will be claimable once the pool is refunded.',
    errPaused: 'Staking is paused for this token',
    errBelowMinimum: 'Below minimum stake',
    errCapExceeded: 'Pool capacity reached',
    errRewardsUnderfunded:
      'The pool cannot reserve rewards for this amount yet',
    errNoPosition: 'No staking position',
    errLocked: 'Position is still locked',
    errNothingToClaim: 'Nothing to claim',
    errInsufficientRewardVault: 'Reward vault cannot cover this payout',
    errExceedsPrincipal: 'Amount exceeds staked balance',
    errProgram: 'Staking program error',
  },
};

export default english;
